import moment from "moment";

import Checklist from "../Checklist";
import { GET, newFetch, PUT } from "../../../../helpers/fetch";
import AlertService from "../../../../components/SweetAlert";
import React from "react";

const MultipleClockIn = ({
  isClockInToday,
  attendanceLogs,
  user,
  group,
  checklist,
  masterClockInOutHandler,
  themeImages,
  loading,
  answers,
  setAnswers,
  t,
  defaultSiteData,
  selectedSchedule,
  overNightShift,
  isWithin5Hours,
  refreshScheduleData,
}) => {
  const handleMarkComplete = async () => {
    const isConfirmed = await AlertService.confirm(
      "Are you sure you want to proceed to the next shift?"
    );
    if (!isConfirmed) return;

    try {
      const api_path = `/associate/schedule/${selectedSchedule?.id}/mark_complete`;
      const response = await newFetch("PUT", api_path);

      if (response.success) {
        AlertService.success("Shift marked as complete successfully!");

        // Refresh the schedule data
        await refreshScheduleData();
      } else {
        AlertService.error("Failed to mark shift as complete.");
      }
    } catch (error) {
      console.error(error);
      AlertService.error("Error marking shift as complete.");
    }
  };

  const computeTotalBreak = (breakin, breakout) => {
    const breakOutTime = moment(breakout, "YYYY-MM-DD HH:mm");
    const breakInTime = moment(breakin, "YYYY-MM-DD HH:mm");

    const duration = moment.duration(breakOutTime.diff(breakInTime));
    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();

    if (breakin != "-" && breakout == "-") {
      return `${moment(breakin).format("HH:mm")} - now`;
    } else if (isNaN(hours) && isNaN(minutes)) {
      return `0h`;
    } else if (hours === 0 && minutes === 0) {
      return `0h`;
    } else {
      return `${hours}h ${minutes}m`;
    }
  };

  function TimeLog({ timeLogs }) {
    const groupedLogs = [];
    let currentRow = {
      time_in: "-",
      break_in: "-",
      break_out: "-",
      time_out: "-",
    };
    const sortedLogs = [...timeLogs].sort((a, b) => a.id - b.id);

    sortedLogs.forEach((log) => {
      const key = "punchtime";

      switch (log.type) {
        case "checkin":
          if (Object.values(currentRow).some((val) => val !== "-")) {
            groupedLogs.push(currentRow);
            currentRow = {
              time_in: "-",
              break_in: "-",
              break_out: "-",
              time_out: "-",
            };
          }
          currentRow.time_in = moment(log[key]).format("HH:mm");
          break;

        case "breakin":
          if (currentRow.break_in !== "-") {
            groupedLogs.push(currentRow);
            currentRow = {
              time_in: "-",
              break_in: "-",
              break_out: "-",
              time_out: "-",
            };
          }
          currentRow.break_in = log[key];
          break;

        case "breakout":
          currentRow.break_out = log[key];
          break;

        case "checkout":
          currentRow.time_out = moment(log[key]).format("HH:mm");
          groupedLogs.push(currentRow);
          currentRow = {
            time_in: "-",
            break_in: "-",
            break_out: "-",
            time_out: "-",
          };
          break;

        default:
          break;
      }
    });

    if (Object.values(currentRow).some((val) => val !== "-")) {
      groupedLogs.push(currentRow);
    }

    const lastRow = groupedLogs[groupedLogs.length - 1] || {};
    const num = groupedLogs.length - 1;
    let flagBreakUsed = false;
    const enableBreak = defaultSiteData?.enable_fix_break !== false;

    return (
      <div className="timeclock__container">
        <div className="timeclock__container-header">
          <p>{t("IN")}</p>
          {!enableBreak && <p>{t("BREAK")}</p>}
          <p>{t("OUT")}</p>
        </div>

        {groupedLogs.map((row, i) => {
          const min = computeTotalBreak(row.break_in, row.break_out);
          if (row.break_in !== "-" && min != "0h 0m") {
            flagBreakUsed = true;
          }

          const showBreakOut =
            !enableBreak &&
            lastRow.break_in !== "-" &&
            lastRow.break_out === "-" &&
            num == i;

          const showBreakInNext =
            !enableBreak &&
            num == i &&
            ((lastRow.time_in !== "-" &&
              lastRow.time_out !== "-" &&
              lastRow.break_in !== "-" &&
              lastRow.break_out !== "-") ||
              (lastRow.time_in === "-" &&
                lastRow.time_out === "-" &&
                lastRow.break_in !== "-" &&
                lastRow.break_out !== "-") ||
              (lastRow.time_out === "-" &&
                lastRow.break_in === "-" &&
                lastRow.break_out === "-") ||
              (lastRow.time_in !== "-" &&
                lastRow.time_out !== "-" &&
                lastRow.break_in === "-" &&
                lastRow.break_out === "-"));

          return (
            <React.Fragment key={i}>
              <div className="timeclock__container-row">
                <p>{row.time_in}</p>
                {!enableBreak && (
                  <div>
                    {(!showBreakInNext ||
                      row.break_in != "-" ||
                      row.time_out != "-") && (
                      <p style={{ width: "100%", color: "#888A8C" }}>
                        {computeTotalBreak(row.break_in, row.break_out)}
                      </p>
                    )}

                    {showBreakInNext && (
                      <button
                        className={"btn btn-break"}
                        onClick={() => {
                          masterClockInOutHandler("break in");
                        }}
                      >
                        <img
                          src={`${themeImages.coffeeBreak}`}
                          height={30}
                          width={30}
                          style={{
                            marginRight: 10,
                            justifyContent: "center",
                          }}
                        />
                        <span className={"label-break"}>
                          {t("Start Break")}
                        </span>
                      </button>
                    )}
                    {showBreakOut && (
                      <button
                        className={"btn btn-break-red"}
                        onClick={() => {
                          masterClockInOutHandler("break out");
                        }}
                      >
                        <img
                          src={`${themeImages.coffeeBreakRed}`}
                          height={30}
                          width={30}
                          style={{
                            marginRight: 10,
                            justifyContent: "center",
                          }}
                        />
                        <span className={"label-break-red"}>
                          {t("Stop Break")}
                        </span>
                      </button>
                    )}
                  </div>
                )}
                <p>{row.time_out}</p>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    );
  }

  return (
    <>
      {isClockInToday() && <TimeLog timeLogs={attendanceLogs} />}

      {isClockInToday() &&
        group &&
        group.length > 0 &&
        ((group[group.length - 1].time_out === "-" &&
          group[group.length - 1].time_in !== "-" &&
          group[group.length - 1].break_out === "-" &&
          group[group.length - 1].break_in === "-") ||
          (group[group.length - 1].time_out === "-" &&
            group[group.length - 1].time_in !== "-" &&
            group[group.length - 1].break_out !== "-" &&
            group[group.length - 1].break_in !== "-") ||
          (group[group.length - 1].time_out === "-" &&
            group[group.length - 1].time_in !== "-" &&
            group[group.length - 1].break_out === "-" &&
            group[group.length - 1].break_in !== "-") ||
          (group[group.length - 1].time_out === "-" &&
            group[group.length - 1].time_in === "-" &&
            group[group.length - 1].break_out === "-" &&
            group[group.length - 1].break_in !== "-")) && (
          <div
            style={{
              width: "100%",
              paddingHorizontal: 20,
              marginTop: 20,
            }}
          >
            <button
              type="button"
              className="btn btn-design btn-brand-red btn-clockinout"
              onClick={() => {
                checklist.length === answers.length &&
                  masterClockInOutHandler("clock out");
              }}
              disabled={
                loading
                  ? loading
                  : (group[group.length - 1].time_in === "-" &&
                      group[group.length - 1].break_in === "-" &&
                      group[group.length - 1].break_out !== "-" &&
                      group[group.length - 1].time_out !== "-") ||
                    (group[group.length - 1].time_in !== "-" &&
                      group[group.length - 1].break_in !== "-" &&
                      group[group.length - 1].break_out !== "-") ||
                    (group[group.length - 1].time_in !== "-" &&
                      group[group.length - 1].break_in === "-" &&
                      group[group.length - 1].break_out === "-" &&
                      group[group.length - 1].time_out === "-")
                  ? false
                  : true
              }
            >
              {loading ? t("Loading") : t("Clock Out")}
            </button>
            {checklist.length !== answers.length && (
              <p style={{ marginTop: 15 }}>
                To enable the clock-out button, please ensure that all{" "}
                <b>Appointed Checklist</b> questions are specified.
              </p>
            )}
          </div>
        )}

      {isClockInToday() ? (
        <>
          {group &&
            group.length > 0 &&
            ((group[group.length - 1].time_out !== "-" &&
              group[group.length - 1].time_in !== "-") ||
              (group[group.length - 1].time_in === "-" &&
                group[group.length - 1].break_out !== "-" &&
                group[group.length - 1].break_in !== "-")) && (
              <div
                style={{
                  width: "100%",
                  paddingHorizontal: 20,
                  marginTop: 20,
                }}
              >
                <button
                  type="button"
                  className="btn btn-design btn-brand btn-clockinout "
                  onClick={() => {
                    masterClockInOutHandler("clock in");
                  }}
                  disabled={loading}
                >
                  {loading ? t("Loading") : t("Clock In")}
                </button>
              </div>
            )}
          {overNightShift && isWithin5Hours && (
            <span
              style={{
                color: "#007bff",
                textDecoration: "underline",
                cursor: "pointer",
                paddingTop: "1rem",
              }}
              onClick={handleMarkComplete}
            >
              Click here to proceed to next shift.
            </span>
          )}
          <div className="timeclock__recentactivities-container">
            <h3 className="mb-2">{t("Recent Activity")}</h3>
            {attendanceLogs.length > 0 &&
              attendanceLogs.map((item, index) => (
                <div key={index} className="timeclock__recentactivities-row">
                  <div
                    className="rounded-circle"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      paddingTop: 12,
                      width: "30%",
                      backgroundColor: ["checkin", "checkout"].includes(
                        item.type
                      )
                        ? "rgba(255, 191, 83, 0.25)"
                        : "rgba(81, 86, 190, 0.25)",
                      borderColor: ["checkin", "checkout"].includes(item.type)
                        ? "rgba(255, 191, 83, 0.25) solid 1px"
                        : "rgba(81, 86, 190, 0.25) solid 1px",
                      height: 45,
                      width: 53,
                    }}
                  >
                    <p
                      style={{
                        textAlign: "center",
                        zIndex: 1,
                      }}
                    >
                      {item.type === "checkin"
                        ? "IN"
                        : item.type === "checkout"
                        ? "OUT"
                        : item.type === "breakin"
                        ? "BRIN"
                        : "BROUT"}
                    </p>
                  </div>
                  {attendanceLogs.length !== index + 1 && (
                    <svg
                      height="70%"
                      width="2"
                      style={{
                        position: "relative",
                        top: 45,
                        left: -28,
                      }} // Replace with appropriate CSS for layout
                    >
                      <line
                        x1="1"
                        y1="0"
                        x2="1"
                        y2="85%"
                        stroke="#ccc"
                        strokeWidth="2"
                        strokeDasharray="4,4"
                      />
                    </svg>
                  )}
                  <div className="timeclock__recentactivities-logs">
                    <p>
                      {moment(item.punchtime).format("DD/MM/YYYY HH:mm:ss")}
                    </p>
                    <p style={{ fontWeight: 400, color: "#495057" }}>
                      {user?.full_name}
                    </p>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        margin: "10px 0px",
                      }}
                    >
                      <p style={{ marginRight: 20 }}>{t("Location")}: </p>
                      <p style={{ fontWeight: 400 }}>{item?.address || "NA"}</p>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </>
      ) : (
        <>
          <img
            src={themeImages.rocket}
            height={150}
            width={150}
            style={{
              marginTop: 20,
              marginHorizontal: 20,
              justifyContent: "center",
            }}
          />

          <div
            style={{
              width: "100%",
              paddingHorizontal: 20,
              marginTop: 20,
            }}
          >
            <button
              type="button"
              className="btn btn-design btn-brand btn-clockinout "
              onClick={() => {
                masterClockInOutHandler("clock in");
              }}
              disabled={loading}
            >
              {loading ? t("Loading") : t("Clock In")}
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default MultipleClockIn;
